export function Pagination({ value, onPage, onSize, loading = false }) {
  if (!value) return null;
  return <div className="flex flex-wrap items-center justify-between gap-3 py-3 text-sm text-gray-600">
    <span>{value.total} resultados · Página {value.page} de {Math.max(1, value.pages)}</span>
    <div className="flex items-center gap-2">
      {onSize && <select aria-label="Resultados por página" value={value.per_page} onChange={e => onSize(Number(e.target.value))} disabled={loading} className="border rounded p-2">
        {[25, 50, 100].map(size => <option key={size} value={size}>{size} por página</option>)}
      </select>}
      <button type="button" disabled={loading || !value.has_prev} onClick={() => onPage(value.page - 1)} className="border rounded px-3 py-2 disabled:opacity-40">Anterior</button>
      <button type="button" disabled={loading || !value.has_next} onClick={() => onPage(value.page + 1)} className="border rounded px-3 py-2 disabled:opacity-40">Siguiente</button>
    </div>
  </div>;
}
